<template>
  <el-form :ref="form.formname" :model="form" :rules="form.rules" label-width="200px" class="etms-router-form">
    <el-form-item label="企业名称 ：" prop="enterprisename">
      <el-input size="mini" placeholder="请输入企业名称" v-model="form.enterprisename" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="统一社会信用代码 ：" prop="unifysocialcreditcode">
      <el-input size="mini" placeholder="请输入统一社会信用代码" v-model="form.unifysocialcreditcode" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="企业法人 ：" prop="legalrepresentiaive">
      <el-input size="mini" placeholder="请输入企业法人" v-model="form.legalrepresentiaive" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="所在地区 ：" prop="regions">
      <el-cascader size="mini" placeholder="请选择所在省市" class="el-width-500" :options="regionmodule.regions" v-model="form.regions" filterable></el-cascader>
    </el-form-item>
    <el-form-item label="所在街道 ：" prop="street">
      <el-input size="mini" placeholder="请输入企业所在街道" v-model="form.street" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="详细地址 ：" prop="enterpriseaddress">
      <el-input size="mini" placeholder="请输入企业详细地址(具体到门牌号)" v-model="form.enterpriseaddress" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="企业电话 ：" prop="enterprisephone">
      <el-input size="mini" placeholder="请输入企业联系电话(如无座机请填写手机号码)" v-model="form.enterprisephone" class="el-width-500"></el-input>
    </el-form-item>
    <el-form-item label="经营类型：" prop="businesstypes">
      <el-select v-model="form.businesstypes" multiple collapse-tags placeholder="请选择经营类型" class="el-select-width-500" v-on:change="businessTypesChange()">
        <el-option v-for="item in constant.businessTypes" :label="item.label" :value="item.value" :key="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="店铺平台：" v-show="form.platformshow">
      <el-select v-model="form.platforms" multiple collapse-tags placeholder="请选择店铺平台" class="el-select-width-500">
        <el-option v-for="item in constant.platforms" :label="item.label" :value="item.value" :key="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="营业执照 ：">
      <el-upload :action="constant.openPaths.enterpriseFileUpload" accept=".jpg,.jpeg,.png" :limit="1" list-type="picture-card" :file-list="form.businesslicense" :http-request="businessLicenseUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="企业LOGO ：">
      <el-upload :action="constant.openPaths.enterpriseFileUpload" accept=".jpg,.jpeg,.png" :limit="1" list-type="picture-card" :file-list="form.logoattachment" :http-request="logoUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="小LOGO ：">
      <el-upload :action="constant.openPaths.enterpriseFileUpload" accept=".jpg,.jpeg,.png" :limit="1" list-type="picture-card" :file-list="form.smalllogoattachment" :http-request="smallLogoUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="VIP等级 ：">
      {{form.viplevel}}<a>特权对比</a>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitEnterprise">保存</el-button>
    </el-form-item>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="false" width="1100px">
      <img :src="dialogImageUrl" alt="" style="max-width:1000px;max-height:1000px;">
    </el-dialog>
  </el-form>
</template>

<script>
import constant from '@/common/constant'

export default {
  data () {
    var enterpriseNameValidate = (rule, value, callback) => {
      var self = this
      this.$ajax.post(
        this.constant.openPaths.existsRegisterEnterpriseName,
        {
          EnterpriseId: this.form.id,
          EnterpriseName: this.form.enterprisename
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }

    var unifySocialCreditCodeValidate = (rule, value, callback) => {
      var self = this
      this.$ajax.post(
        this.constant.openPaths.existsRegisterUnifySocialCreditCode,
        {
          EnterpriseId: this.form.id,
          UnifySocialCreditCode: this.form.unifysocialcreditcode
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          callback()
        } else {
          callback(new Error(res.data.msg))
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }

    return {
      dialogVisible: false,
      viplevelpath: constant.linkpaths.viplevelpath,
      userinfo: this.$cookies.get('userinfo'),
      dialogImageUrl: '',
      form: {
        formname: 'entform',
        id: '',
        enterprisename: '',
        unifysocialcreditcode: '',
        legalrepresentiaive: '',
        regions: [],
        street: '',
        enterpriseaddress: '',
        businesstypes: [],
        platforms: [],
        platformshow: false,
        ecstate: '',
        tmstate: '',
        wmstate: '',
        viplevel: '白银TMS',
        enterprisephone: '',
        optimisticlock: '',
        blattachmentid: '',
        businesslicense: [],
        logoattachmentid: '',
        logoattachment: [],
        smalllogoattachmentid: '',
        smalllogoattachment: [],
        state: '',
        rules: {
          enterprisename: [
            { required: true, message: '请填写企业名称', trigger: 'blur' },
            { max: 100, message: '长度在100个字符内', trigger: 'blur' },
            { validator: enterpriseNameValidate, trigger: 'blur' }
          ],
          unifysocialcreditcode: [
            { required: true, message: '请填写统一社会信用代码', trigger: 'blur' },
            { max: 30, message: '长度在30个字符内', trigger: 'blur' },
            { validator: unifySocialCreditCodeValidate, trigger: 'blur' }
          ],
          legalrepresentiaive: [
            { required: true, message: '请填写企业法人', trigger: 'blur' }
          ],
          regions: [
            { required: true, message: '请选择城市', trigger: 'change' }
          ],
          street: [
            { required: true, message: '请填写企业所在街道', trigger: 'blur' },
            { max: 30, message: '长度在30个字符内', trigger: 'blur' }
          ],
          enterpriseaddress: [
            { required: true, message: '请填写企业详细地址', trigger: 'blur' },
            { max: 100, message: '长度在100个字符内', trigger: 'blur' }
          ],
          enterprisephone: [
            { required: true, message: '请填写企业联系电话', trigger: 'blur' },
          ],
          businesstypes: [
            { required: true, message: '请选择企业经营类型', trigger: 'change' },
          ]
        }
      }
    }
  },
  mounted () {
    if (this.userinfo !== null && this.userinfo !== undefined) {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken
      }
      var self = this
      this.$ajax({
        method: 'post',
        url: constant.openPaths.getEnterpriseInfo,
        data: data
      }).then(function (res) {
        if (res.data.code === 200) {
          var result = res.data.result
          self.form.id = result.id
          self.form.enterprisename = result.enterpriseName
          self.form.unifysocialcreditcode = result.unifySocialCreditCode
          self.form.legalrepresentiaive = result.legalRepresentative

          let businesstypes = new Array()

          result.businessScope.split(',').forEach(item => {
            if (item !== '') {
              businesstypes.push(parseInt(item))
            }
          })

          self.form.businesstypes = businesstypes

          let platforms = new Array()

          result.platforms.split(',').forEach(item => {
            platforms.push(parseInt(item))
          })

          self.form.platforms = platforms
          self.businessTypesChange()
          self.form.regions = result.regions.split(',')
          self.form.street = result.street
          self.form.enterpriseaddress = result.enterpriseAddress
          self.form.enterprisephone = result.enterprisePhone
          self.form.optimisticlock = result.optimisticLock
          self.form.blattachmentid = result.blAttachmentId
          if (result.blAttachmentPath !== undefined && result.blAttachmentPath !== null && result.blAttachmentPath !== '') {
            self.form.businesslicense = [{ name: 'businesslicense', url: self.constant.openEmsUrl + result.blAttachmentPath }]
          }
          self.form.logoattachmentid = result.logoAttachmentId
          if (result.logoAttachmentPath !== undefined && result.logoAttachmentPath !== null && result.logoAttachmentPath !== '') {
            self.form.logoattachment = [{ name: 'logo', url: self.constant.openEmsUrl + result.logoAttachmentPath }]
          }
          self.form.smalllogoattachmentid = result.smallLogoAttachmentId
          if (result.smallLogoAttachmentPath !== undefined && result.smallLogoAttachmentPath !== null && result.smallLogoAttachmentPath !== '') {
            self.form.smalllogoattachment = [{ name: 'smalllogo', url: self.constant.openEmsUrl + result.smallLogoAttachmentPath }]
          }
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(function (error) {
        self.$message.error(error)
      })
    }
  },
  methods: {
    businessTypesChange () {
      this.form.platformshow = false
      this.form.businesstypes.forEach(item => {
        if (item === 1) {
          this.form.platformshow = true
        }
      })
    },
    enterpriseFileUpload (formData, content, filetype) {
      var self = this

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(this.constant.openPaths.enterpriseFileUpload, formData, config).then(res => {
        if (res.data.code === 200) {
          self.form.optimisticlock = res.data.result.optimisticLock
          switch (filetype) {
            case 1:
              self.form.businesslicense = [{ name: 'businesslicense', url: self.constant.openEmsUrl + res.data.result.attachmentPath }]
              break
            case 2:
              self.form.logoattachment = [{ name: 'logo', url: self.constant.openEmsUrl + res.data.result.attachmentPath }]
              break
            case 3:
              self.form.smalllogoattachment = [{ name: 'smalllogo', url: self.constant.openEmsUrl + res.data.result.attachmentPath }]
              break
          }
          var result = res.data.result
          content.onSuccess(res.data.msg)
          self.$message({
            message: res.data.msg,
            type: 'success'
          })
        }
        else {
          self.$message.error(res.data.msg)
          content.onError(res.data.msg)
        }
      })
    },
    businessLicenseUpload (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('OptimisticLock', this.form.optimisticlock)
      formData.append('FileType', 1)
      formData.append('AttachmentId', this.form.blattachmentid)
      formData.append('file', content.file)

      this.$confirm('更改营业执照需要重新审核,是否继续？', '提示', {
        confirmButtonText: '继续',
        canelButtonText: '取消'
      }).then(() => {
        this.enterpriseFileUpload(formData, content)
      })
    },
    logoUpload (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('OptimisticLock', this.form.optimisticlock)
      formData.append('FileType', 2)
      formData.append('AttachmentId', this.form.logoattachmentid)
      formData.append('file', content.file)
      this.enterpriseFileUpload(formData, content)
    },
    smallLogoUpload (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('OptimisticLock', this.form.optimisticlock)
      formData.append('FileType', 3)
      formData.append('AttachmentId', this.form.smalllogoattachmentid)
      formData.append('file', content.file)
      this.enterpriseFileUpload(formData, content)
    },
    handleRemove (file, fileList) {
    },
    handleSuccess (response, file, fileList) {
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    submitEnterprise () {
      this.$refs[this.form.formname].validate(vali => {
        if (vali) {
          var self = this
          this.$ajax.post(this.constant.openPaths.updateEnterpriseInfo,
            {
              UserId: this.userinfo.id,
              EnterpriseId: this.userinfo.enterpriseId,
              LoginToken: this.userinfo.loginToken,
              OptimisticLock: this.form.optimisticlock,
              EnterpriseName: this.form.enterprisename,
              UnifySocialCreditCode: this.form.unifysocialcreditcode,
              LegalRepresentative: this.form.legalrepresentiaive,
              BusinessScope: this.form.businesstypes,
              Platforms: this.form.platforms,
              Regions: this.form.regions,
              Street: this.form.street,
              EnterpriseAddress: this.form.enterpriseaddress,
              EnterprisePhone: this.form.enterprisephone
            }
          ).then(res => {
            if (res.data.code === 200) {
              self.form.optimisticlock = res.data.result
              self.$message({ message: res.data.msg, type: 'success' })
            } else {
              self.$message.error(res.data.msg)
            }
          }).catch(error => { self.$message.error(error) })
        }
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

a {
  padding: 0 10px;
  color: rgb(255, 208, 75);
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/ent_setting.vue